export default __webpack_public_path__ + "static/media/filter_arrow.bc8836f8.svg";